<p-dialog
  [header]="translationKeys.materialSelectDialogComponent.html.dialogTitle | translate"
  [(visible)]="showDialog"
  [modal]="true"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  [styleClass]="'category-dialog'"
  (onHide)="cancelEvent.emit()"
  [contentStyleClass]="'scip-dialog-content'"
>
  <div style="height: 100%; min-height: 300px; display: flex; justify-content: center">
    <div style="flex: 1 1 60%">
      <avano-table
        [tableRef]="tt"
        [headerText]="translationKeys.materialSelectDialogComponent.html.availableMaterialCategories | translate">
        <p-table
          #tt
          [value]="filteredMaterials"
          selectionMode="single"
          [columns]="cols"
          [selection]="selectedNodeLeft"
          (selectionChange)="setAvailableLeft($event)"
          [scrollable]="true"
          scrollHeight="flex"
          styleClass="material-category-tree-table-available"
          [resizableColumns]="true"
          (onFilter)="selectedNodeLeft = undefined"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngFor="let col of cols; let i = index"
                [avanoTableColumnHeader]="col"
                [isLastSortable]="i === cols.length - 1"
                class="scip-avano-table-no-resize"
              >
                <avano-text-input-column-filter
                  [filterField]="col.field"
                  style="flex-grow: 1;"
                  [style.visibility]="col.filterable === false ? 'hidden' : 'visible'"
                ></avano-text-input-column-filter>
              </th>
              <th avanoTableFiltersReset pFrozenColumn [frozen]="true" alignFrozen="right"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
              <td *ngFor="let col of columns">
                <div avanoEllipsis>{{ rowData[col.field] }}</div>
              </td>
              <td class="avano-table-header-filterreset-placeholder">
                <!-- Needed as placeholder because of "table"-behavior -->
              </td>
            </tr>
          </ng-template>
        </p-table>
      </avano-table>
    </div>
    <div style="flex: 0" class="category-selection-button-column">
      <button
        avanoButton
        [icon]="'icon-content-chevron-right'"
        [disabled]="!selectedNodeLeft"
        class="category-selection-button"
        (click)="transferSelection()"
      ></button>
      <button
        avanoButton
        [icon]="'icon-content-chevron-left'"
        [disabled]="!selectedNodeRight"
        class="category-selection-button"
        (click)="removeSelectedNode()"
      ></button>
      <button
        avanoButton
        [icon]="'icon-content-chevron-all-left'"
        [disabled]="!selectedCategories?.length"
        class="category-selection-button"
        (click)="removeAll()"
      ></button>
    </div>
    <div style="flex: 1 1 30%">
      <avano-table
      [tableRef]="selectedCategoriesTable"
      [headerText]="translationKeys.materialSelectDialogComponent.html.selectedMaterialCategories | translate"
      >
        <p-table
          #selectedCategoriesTable
          [value]="selectedCategories"
          [selectionMode]="'single'"
          [selection]="selectedNodeRight"
          (selectionChange)="setSelectedRight($event)"
          [scrollable]="true"
          [scrollHeight]="'flex'"
          [styleClass]="'material-category-tree-table-selected'"
          [resizableColumns]="true"
          [columns]="selectedCategoriesColumns"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngFor="let col of selectedCategoriesColumns; let i = index"
                [avanoTableColumnHeader]="col"
                [isLastSortable]="i === cols.length - 1"
                class="scip-avano-table-no-resize-filter"
              ></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
              <td *ngFor="let col of columns">
                <div avanoEllipsis>{{ rowData[col.field] }}</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </avano-table>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.cancel | translate"
      [icon]="'icon-content-cancel'"
      (click)="cancelEvent.emit()"
    ></button>
    <button
      type="button"
      avanoButton
      [buttonType]="'callToAction'"
      [label]="translationKeys.commonTranslationKey.btn.apply | translate"
      [icon]="'icon-content-add'"
      (click)="saveEvent.emit(selectedCategories)"
    ></button>
  </ng-template>
</p-dialog>
